import axios from 'axios';
import apiConfig from '../../api.config';

export default async function checkInvoiceSFTPConnection(body) {
  const {
    host,
    URIs: { checkInvoiceSFTPConnection },
  } = apiConfig;

  const uri = `${host}${checkInvoiceSFTPConnection}`;

  return await axios.post(uri, body).then(res => res.data);
}
